export const PATTERN_PACKAGE = '@orangelv/mizuno-patterns'
export const CLIENT_ASSET_PACKAGES = [{ name: PATTERN_PACKAGE, dir: 'dist' }]
